import React, {Component} from "react";
import moment from "moment";
import "moment/locale/zh-cn";

moment.locale("zh-cn");

class Calendar extends Component {
  state = {
    cur_year: "",
    cur_month: "",
    days: [],
    hasEmptyGrid: false,
    weekInMonth: 1
  };

  componentDidMount() {
    this.setNowDate(this.props.selectDate, this.props.index);
  }

  componentWillUpdate(Props) {
    if (!this.props.selectDate.isSame(Props.selectDate) || this.props.index !== Props.index) {
      this.setNowDate(Props.selectDate, Props.index);
    }
  }

  // 设置当前时间
  setNowDate(selectDate, index) {
    let date = moment(selectDate);
    let dateYear = date.year();
    let dateMonth = date.month() + 1;
    dateMonth = dateMonth + index;
    var test = new Date(date._d.getTime())
    test.setMonth(dateMonth);
    if (dateMonth > 12) {
      dateYear = dateYear + 1;
      dateMonth = dateMonth - 12;
    }
    this.calculateEmptyGrids(dateYear, dateMonth);
    this.calculateDays(dateYear, dateMonth);
    this.getDetailDayOfWeek(selectDate, dateYear, dateMonth);
    this.setState({
      cur_year: dateYear,
      cur_month: dateMonth
    });
  }

  // 计算空了的日子
  calculateEmptyGrids(year, month) {
    const firstDayOfWeek = this.getFirstDayOfWeek(year, month);
    let empytGrids = [];
    if (firstDayOfWeek > 0) {
      for (let i = 0; i < firstDayOfWeek; i++) {
        empytGrids.push(i);
      }
      this.setState({
        hasEmptyGrid: true,
        empytGrids
      });
    } else {
      this.setState({
        hasEmptyGrid: false,
        empytGrids: []
      });
    }
  }

  // push日子进去
  calculateDays(year, month) {
    let days = [];
    const thisMonthDays = this.getThisMonthDays(year, month);
    for (let i = 1; i <= thisMonthDays; i++) {
      days.push(i);
    }
    this.setState({
      days
    });
  }

  // 获取这个月有几天
  getThisMonthDays(year, month) {
    return new Date(year, month, 0).getDate();
  }

  // 获取第一天是星期几
  getFirstDayOfWeek(year, month) {
    return (new Date(Date.UTC(year, month - 1, 1)).getDay() + 6) % 7;
  }

  // 获取最后一天是星期几
  getLastDayOfWeek(year, month) {
    return new Date(Date.UTC(year, month, 0)).getDay();
  }

  // 获得某个日子是这个月第几周
  getDetailDayOfWeek(selectDate, year, month) {
    const firstDayOfWeek = this.getFirstDayOfWeek(year, month);
    let days = selectDate.day() === 0 ? 7 : selectDate.day();
    let weekInMonth = parseInt((selectDate.get("date") + (firstDayOfWeek - days)) / 7);
    this.setState({weekInMonth: weekInMonth});
  }

  render() {
    const {cur_year, cur_month} = this.state;
    let temp = new Date();
    temp.setDate(1);
    temp.setMonth(cur_month - 1);
    temp.setFullYear(cur_year);
    return (
      <React.Fragment>
        <div className="index-calendar-view-div">
          <span className="index-canlendar-border"/>
          <span className="index-calendar-title">
              <span className="side"></span>
            {temp.getFullYear() || "-"} 年 {(temp.getMonth() + 1)} 月</span>
        </div>
        <div className="index-calendar-view">{this.renderDate()}</div>
      </React.Fragment>
    );
  }

  renderDate() {
    const {hasEmptyGrid, days, empytGrids, weekInMonth, cur_year, cur_month} = this.state;
    const {checked, selectDate, dateWidth} = this.props;
    let activeDay = selectDate.get("date");
    let isCurMonth = cur_month === selectDate.month() + 1;
    let translateY = weekInMonth * dateWidth + "px";
    return (
      <div className="index-date-bg" style={{transform: checked ? "translateY(0)" : `translateY(-${translateY})`}}>
        {hasEmptyGrid && empytGrids.map((data, idx) => {
          return <div key={idx}/>;
        })}
        {days.map((day, idx) => {
          let c_date = new Date();
          let s_date = moment([cur_year, cur_month - 1, day])._d;
          let flag = c_date.getFullYear() < s_date.getFullYear() || c_date.getMonth() < s_date.getMonth() || c_date.getDate() <= s_date.getDate();
          if (isCurMonth) {
            return (
              <div key={idx} onClick={() => {
                this.props.handleDateChange(moment([cur_year, cur_month - 1, day]));
              }}
                   className={activeDay === day ? "index-detail-date active" : "index-detail-date"}>
                <span className="index-day" style={{color: flag ? "" : "rgba(255,255,255,0.3)"}}>{day}</span>
              </div>
            );
          } else {
            return (
              <div
                key={idx}
                onClick={() => {
                  this.props.handleDateChange(moment([cur_year, cur_month - 1, day]));
                }}
                className="index-detail-date"
              >
                <span className="index-day" style={{color: flag ? "" : "rgba(255,255,255,0.3)"}}>{day}</span>
              </div>
            );
          }
        })}
      </div>
    );
  }
}

export default Calendar;
